import Vue from 'vue'
import Router from 'vue-router'

import Information from './views/Information/Information.vue';

Vue.use(Router)

let router = new Router({
    mode: "hash",
    routes: [{
            path: '/',
            name: 'Information',
            meta: {
                title: '知东莞', // 路由切换时是否需要切换网页title
            },
            component: Information
        },
        // 莞香号
        {
            path: '/subscribe',
            name: '/Subscribe',
            meta: {
                title: '资讯', // 路由切换时是否需要切换网页title
            },
            component: () =>
                import ('./views/Information/Subscribe.vue'), // 路由懒加载
        },
        // 订阅号全部分类
        {
            path: '/allType',
            name: '/AllType',
            meta: {
                title: '资讯', // 路由切换时是否需要切换网页title
                navShow: false,
            },
            component: () =>
                import ('./views/Information/AllType.vue'), // 路由懒加载
        },
        // 我的订阅
        {
            path: '/myDy',
            name: '/MyDy',
            meta: {
                title: '我的订阅', // 路由切换时是否需要切换网页title
                navShow: false,
            },
            component: () =>
                import ('./views/Information/MyDy.vue'), // 路由懒加载
        },
        // 全部订阅
        {
            path: '/allDy',
            name: '/AllDy',
            meta: {
                title: '资讯', // 路由切换时是否需要切换网页title
                navShow: false,
            },
            component: () =>
                import ('./views/Information/AllDy.vue'), // 路由懒加载
        },
        {
            path: '/main',
            name: 'FindMain',
            meta: {
                title: '发现',
            },
            redirect: '/main/ask',
            component: () =>
                import ('./views/Find/Main.vue'), // 路由懒加载
            children: [
                // 晒照首页
                {
                    path: 'find',
                    name: 'Find',
                    meta: {
                        title: '发现',
                    },
                    component: () =>
                        import ('./views/Find/ShowImage/Find.vue')
                },
                // 晒照列表
                {
                    path: 'findList',
                    name: 'FindList',
                    meta: {
                        title: '发现',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/ShowImage/FindList.vue')
                },
                // 晒照话题列表
                {
                    path: 'topicList',
                    name: 'TopicList',
                    meta: {
                        title: '话题',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/ShowImage/TopicList.vue')
                },
                // 晒照话题详情
                {
                    path: 'topicDetails',
                    name: 'TopicDetails',
                    meta: {
                        title: '知东莞·知天下',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/ShowImage/TopicDetails.vue')
                },
                 // 晒照发布
                 {
                    path: 'topicApply',
                    name: 'TopicApply',
                    meta: {
                        title: '知东莞·知天下',
                        navShow: false,
                        tabMenu: false,
                        
                    },
                    component: () =>
                        import ('./views/Find/ShowImage/TopicApply.vue')
                },
          
                {
                    path: 'recommend',
                    name: 'Recommend',
                    meta: {
                        title: '精选推荐',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/ShowImage/Recommend.vue')
                },
                // 问吧首页
                {
                    path: '/main',
                    name: 'Ask',
                    meta: {
                        title: '发现',
                    },
                    component: () =>
                        import ('./views/Find/Ask/Ask.vue')
                },
                // 邀请回答列表
                {
                    path: '/invite',
                    name: 'Invite',
                    meta: {
                        title: '问吧',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/Ask/Invite.vue')
                },
                // 问吧话题列表
                {
                    path: '/askTopic',
                    name: 'AskTopic',
                    meta: {
                        title: '问吧',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/Ask/AskTopic.vue')
                },
                // 问吧话题搜索
                {
                    path: '/askSearch',
                    name: 'AskSearch',
                    meta: {
                        title: '问吧',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/Ask/AskSearch.vue')
                },
                // 问吧话题详情列表
                {
                    path: '/askTopicDet',
                    name: 'AskTopicDet',
                    meta: {
                        title: '问吧',
                        navShow: false,
                        tabMenu: false
                    },
                    component: () =>
                        import ('./views/Find/Ask/AskTopicDet.vue')
                },
            ],
        },
        // 拍客
        {
            path: '/patting',
            name: 'Patting',
            meta: {
                title: '拍客',
            },
            redirect: '/patting/comment',
            component: () =>
                import ('./views/Patting/Patting.vue'),
            children: [
                // 推荐
                {
                    path: 'comment',
                    name: 'Comment',
                    meta: {
                        title: '拍客',
                    },
                    component: () =>
                        import ('./views/Patting/Comment.vue')
                },
                // 订阅
                {
                    path: 'order',
                    name: 'Order',
                    meta: {
                        title: '拍客',
                    },
                    component: () =>
                        import ('./views/Patting/Order.vue')
                },
                // 全部
                {
                    path: 'all',
                    name: 'All',
                    meta: {
                        title: '拍客',
                    },
                    component: () =>
                        import ('./views/Patting/All.vue')
                },
            ]
        },
        {
            path: '/audio/list',
            name: 'audioList',
            meta: {
                navShow: false,
                title: "音频列表"
            },
            component: () =>
                import ('./views/Audio/List')
        },
        {
            path: "/otherAudio/detail",
            name: "otherAudio",
            meta: {
                navShow: false,
                title: "其它电台"
            },
            component: () =>
                import ('./views/OtherAudio/Detail')
        },
        {
            path: "/virtual/list",
            name: "otherAudio",
            meta: {
                navShow: false,
                title: "V电台"
            },
            component: () =>
                import ('./views/Virtual/List')
        },
        {
            path: '/audio/detail',
            name: 'audioDetail',
            meta: {
                navShow: false,
                title: "知东莞·知天下"
            },
            component: () =>
                import ('./views/Audio/Detail')
        },
        {
            path: '/audio/single',
            name: 'audioSingle',
            meta: {
                navShow: false,
                title: "知东莞·知天下"
            },
            component: () =>
                import ('./views/Audio/Single')
        },
        // 视频列表
        {
            path: '/video/list',
            name: 'videoLise',
            meta: {
                title: "视频列表",
                navShow: false
            },
            component: () =>
                import ("./views/Video/List/index")
        },
        {
            path: "/video/detail",
            name: "videoDetail",
            meta: {
                title: "知东莞·知天下",
                navShow: false
            },
            component: () =>
                import ('./views/Video/Detail/index')
        },
        {
            path: '/new/topicList',
            name: 'newTopicList',
            meta: {
                title: "话题",
                navShow: false
            },
            component: () =>
                import ('./views/Other/NewTopicList')
        },
        {
            path: "/new/topicDetail",
            name: "newTopicDetail",
            meta: {
                title: "知东莞·知天下",
                navShow: false
            },
            component: () =>
                import ('./views/Other/TopicDetail')
        },
        {
            path: "/new/postDetail",
            name: "newPostDetail",
            meta: {
                title: "知东莞·知天下",
                navShow: false
            },
            component: () =>
                import ("./views/Other/PostDetail")
        },
        // 拍客话题列表
        {
            path: '/patTopList',
            name: 'PatTopList',
            meta: {
                title: '拍客',
                navShow: false,
            },
            component: () =>
                import ('./views/Patting/PatTopList.vue')
        },
        // 拍客话题详情页
        {
            path: '/patTopDetails',
            name: 'PatTopDetails',
            meta: {
                title: '拍客',
                navShow: false,
            },
            component: () =>
                import ('./views/Patting/PatTopDetails.vue')
        },
        {
            path: '/live',
            name: 'Live',
            meta: {
                title: '直播',
            },
            component: () =>
                import ('./views/Live/Live.vue')
        },
        // 404
        // {
        //     path: "*", // 此处需特别注意置于最底部
        //     redirect: "/"
        // }
    ]
})

export default router